export interface LogoProps {
  className?: string;
  size?: number;
}

// Official team colors
export const WARRIORS = {
  blue: '#1D428A',
  gold: '#FDB927',
};

export const NINERS = {
  red: '#AA0000',
  gold: '#B3995D',
};
